import 'babel-polyfill';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import routes from './routes';
import { ready, getAppInfo, $http } from '../../lib/kbApp/kbJsBridgePromise';
import { UpgradeDialog } from '../../components';
import { getWelfareCenterParams } from '../../rootStore';


const routeMap = () => (
	<Switch>
		{routes.map(({ path, exact, component }) => (
			<Route
				exact={exact}
				path={path}
				key={path}
				component={component}
			></Route>
		))}
	</Switch>
);

const App = ({ mapAppInfo, mapAppMainAccount }) => {
  ready().then(() => {
    getAppInfo().then((res) => {
      mapAppInfo(res);
    });
  });

  return (
    <Router>
      <UpgradeDialog/>
			<Route render={routeMap}></Route>
		</Router>
  );
};

const mapDispatchToProps = dispatch => ({
  mapAppInfo(data) {
    dispatch({
      type: 'map_app_info',
      data,
    });
  },
  // mapAppMainAccount(data) {
  // 	dispatch({
  // 		type: 'map_app_main_account',
  // 		data
  // 	});
  // }
});


export default connect(
  null,
  mapDispatchToProps
)(App);
